import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LocaleService } from '@shared/services/locale.service';

@Component({
	selector: 'app-payment-confirm',
	templateUrl: './payment-confirm.component.html',
	styleUrls: ['./payment-confirm.component.scss'],
})
export class PaymentConfirmComponent implements OnInit {
	constructor(private route: ActivatedRoute, private title: Title, public locale: LocaleService, private router: Router) {}

	embedded: boolean = false;
	adID: string;
	catID: String;
	from: string;

	onYes() {
		this.router.navigate(['/placead/success'], {
			queryParams: {
				id: this.adID,
				Cat: this.catID,
			},
		});
	}

	onNo() {
		this.router.navigate(['/payment/tier'], {
			queryParams: {
				adID: this.adID,
				from: this.from,
			},
		});
	}

	ngOnInit(): void {
		this.route.queryParams.subscribe((queries: Params) => {
			if (queries['adID']) this.adID = queries['adID'];
			if (queries['catID']) this.catID = queries['catID'];
			if (queries['from']) this.from = queries['from'];

			if (queries['embedded']) this.embedded = queries['embedded'];
		});

		// this.title.setTitle(this.locale.translations['payment']['n343'] + ' | ' + this.locale.translations['header']['n0']);
	}
}
